import { stringify } from 'hub-http/helpers/params';
import { List as ImmutableList } from 'immutable';
import { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import UsageTracker from '../../../utils/UsageTracker';
import { useGetToolRecommendations } from '../queries/softwareDiscoveryHooks';
import { SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS } from '../../../constants/Navigation';
import { jsx as _jsx } from "react/jsx-runtime";
const CARD_HEIGHT = 305;
const ToolCard = ({
  cardWidth,
  contentName,
  experimentUseCase,
  iconWidth,
  linkText,
  name,
  resourceTitle,
  title,
  toolSlug
}) => {
  const handleToolClick = () => UsageTracker.track('contentInteraction', {
    action: 'software-discovery-tool-click',
    contentName,
    linkText,
    resourceTitle,
    useCases: [experimentUseCase]
  });
  return /*#__PURE__*/_jsx(Box, {
    basis: cardWidth,
    shrink: 0,
    children: /*#__PURE__*/_jsx(Link, {
      "data-test-id": `tool-recommendation-card-${name}`,
      target: "_blank",
      to: {
        pathname: `/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}/${toolSlug}`,
        search: stringify({
          useCases: experimentUseCase
        })
      },
      children: /*#__PURE__*/_jsx(SelectableButton, {
        block: true,
        height: CARD_HEIGHT,
        onClick: handleToolClick,
        paddingBlockStart: "500",
        selected: false,
        size: "large",
        title: title,
        children: /*#__PURE__*/_jsx(Illustration, {
          name: name,
          width: iconWidth
        })
      })
    })
  });
};
const ToolRecommendationsForLearningContent = ({
  cardWidth = 350,
  contentName,
  flexGap = '0',
  iconWidth = '65%',
  renderRecommendations = commonContent => commonContent,
  toolsToDisplay = 3,
  useCases: mayBeListUseCase
}) => {
  const useCases = useMemo(() => {
    if (ImmutableList.isList(mayBeListUseCase)) {
      return mayBeListUseCase.toArray();
    }
    return mayBeListUseCase;
  }, [mayBeListUseCase]);
  const toolRecommendations = useGetToolRecommendations(useCases);
  useEffect(() => {
    if (toolRecommendations) {
      UsageTracker.track('interaction', {
        action: 'software-discovery-ui-viewed',
        useCases
      });
    }
  }, [toolRecommendations, useCases]);
  if (!toolRecommendations) {
    return null;
  }
  const {
    experimentUseCase,
    toolCardNames,
    toolNames,
    toolLabelTitles,
    toolSlug
  } = toolRecommendations;
  return renderRecommendations( /*#__PURE__*/_jsx(Flex, {
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: flexGap,
    justifyContent: "space-around",
    children: [...Array(toolsToDisplay)].map((_, index) => /*#__PURE__*/_jsx(ToolCard, {
      cardWidth: cardWidth,
      contentName: contentName,
      experimentUseCase: experimentUseCase,
      iconWidth: iconWidth,
      linkText: I18n.text(toolLabelTitles[index]),
      name: toolCardNames[index],
      resourceTitle: toolNames[index],
      title: /*#__PURE__*/_jsx(Text, {
        textDecoration: "none",
        typography: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: toolLabelTitles[index]
        })
      }),
      toolSlug: toolSlug[index]
    }, index))
  }));
};
export default ToolRecommendationsForLearningContent;